export const GET_PURCHASE_COIN_HISTORY = "GET_PURCHASE_COIN_HISTORY";
export const GET_VIP_PLAN_HISTORY = "GET_VIP_PLAN_HISTORY";
